import { render, staticRenderFns } from "./ProgressioCrud.vue?vue&type=template&id=3241990b&scoped=true&"
import script from "./ProgressioCrud.vue?vue&type=script&lang=js&"
export * from "./ProgressioCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3241990b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
